import React, { useState } from 'react';

import Show from 'components/Show';
import Modal from 'components/Modal';
import Nothing from 'components/Misc/Nothing';
import { Title } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

import Add from 'containers/Administrator/Users/Create/Student/Warrants/Add';
import Warrant from 'containers/Administrator/Users/Create/Student/Warrants/Warrant';

const Warrants = ({ grade }) => {
	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Toggle modal's visibility
	const handleModal = () => setModal(m => !m);

	return (
		<>
			<div className="flex items-center space-x-2">
				<Title
					title="Rīkojumi"
					subtitle={grade.warrants?.length ? `Pievienoti (${grade.warrants?.length})` : 'Pievienot rīkojumus'}
					className="flex-1 text-sm"
				/>

				<Button
					small
					square
					icon="history_edu"
					theme="success"
					onClick={handleModal}
				/>
			</div>

			<Modal title="Pievienot rīkojumus" visible={modal} handleModal={handleModal}>
				<div className="space-y-4">
					{/* Warrant addition */}
					<Add grade={grade} />

					<Title title="Rīkojumi" />

					{/* Show nothing if no warrant's added */}
					<Nothing visible={!grade?.warrants?.length} />

					{/* Show warrant collection */}
					<Show if={grade?.warrants?.length}>
						<div className="space-y-4">
							{grade?.warrants?.map(warrant => (
								<Warrant key={warrant.key} gradeId={grade.id} warrant={warrant} />
							))}
						</div>
					</Show>
				</div>

				{/* Modal's controls */}
				<div className="mt-4 flex justify-end">
					<Button
						icon="check"
						theme="success"
						value="Saglabāt"
						onClick={handleModal}
					/>
				</div>
			</Modal>
		</>
	);
};

export default Warrants;